$(document).ready(function() {
  // $("#submit_instant_book_btn").click(function(e) {
  //   $("input:checkbox[class='instant_book_checkbox']:checked").each(function () {
  //     if($(api_provider_id(this))[0].value == "") {
  //       e.preventDefault();
  //       alert('Please enter valid API provider');
  //       return false;
  //     }
  //   });
  // });

  $(".instant_book_checkbox").change(function() {
    if(this.checked) {
      return false
    }
    $(api_provider_id(this))[0].value = ''
  });

  function api_provider_id(elm) {
    id = elm.dataset.courseId
    return '#course_'+id+'_api_provider'
  }

  $(".allowed_switch").bootstrapSwitch({
    onSwitchChange: function(e, state) {
      if(state) {
        $("#rules").removeClass('disabled')
      } else {
        $("#rules").addClass('disabled')
      }
    }
  });

  $("#instant_book_open_all_time").on('change', function() {
    if(this.checked) {
      $("#customizations_rules").addClass('disabled');
      $("#instant_book_customize")[0].checked = false;
    } else {
      $("#customizations_rules").removeClass('disabled');
      $("#instant_book_customize")[0].checked = true;
    }
  });

  $("#instant_book_customize").on('change', function() {
    if(this.checked) {
      $("#customizations_rules").removeClass('disabled');
      $("#instant_book_open_all_time")[0].checked = false;
    } else {
      $("#customizations_rules").addClass('disabled');
      $("#instant_book_open_all_time")[0].checked = true;
    }
  });

  $('#rules').on('cocoon:after-insert', function(e, insertedItem, originalEvent) {
    $('.selectpicker').selectpicker('refresh')
  });
});
